// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1zheA","lds-ring":"styles_lds-ring__3lXjP"};